/**
 * Shared project navigation used by both the grid tile and the list row.
 * Expects the host component to have a `project` prop and the `user` getter.
 */
import { mapGetters } from 'vuex';
import jwt from 'jsonwebtoken';
import firebase from 'firebase/app';
import 'firebase/functions';
import NavBus from '@/buses/nav';

export default {
    computed: {
        ...mapGetters(['user'])
    },
    methods: {
        createToken() {
            const payload = { userId: this.user.uid };
            const options = { expiresIn: process.env.VUE_APP_EXPIRETIME };
            return jwt.sign(payload, process.env.VUE_APP_SECRETKEY, options);
        },
        // The legacy editor exchanges this uid for a sign-in token at
        // getCurrentUserByUid, which since 23 Sept 2026 only honours a hand-off the
        // signed-in account armed itself in the last two minutes. The JWT above is
        // kept only because the frozen legacy receiver still expects its shape; it
        // is not a security boundary (the key ships in this bundle).
        async legacyUrl() {
            try {
                await firebase.functions().httpsCallable('armLegacyHandoff')();
            } catch (e) {
                // Go anyway: legacy then shows its own sign-in, which is the
                // correct fallback rather than a dead click.
                console.error('[legacy hand-off] could not arm:', e && e.message);
            }
            return `${process.env.VUE_APP_LAGACY_URL}/project/${this.project.id}?uid=${this.createToken()}`;
        },
        async selectProject() {
            if (this.project.isNew) {
                this.$router.push(`/project/${this.project.id}`);
                this.$router.go(0);
            } else {
                window.location.href = await this.legacyUrl();
            }
        },
        editProject(e) {
            if (this.project.isNew) {
                this.$router.replace(`/project/${this.project.id}`, () => {
                    NavBus.$emit('project-settings-nav.open.force', () => {});
                });
            } else {
                // Stop the event before the await: after it, the click has already
                // bubbled and the tile's own handler would have fired.
                if (e) {
                    e.stopPropagation();
                    e.preventDefault();
                }
                this.legacyUrl().then((url) => {
                    window.location.href = url;
                    NavBus.$emit('project-settings-nav.open.force', () => {});
                });
                return;
            }
            if (e) {
                e.stopPropagation();
                e.preventDefault();
            }
        }
    }
};


// WEBPACK FOOTER //
// ./src/mixins/projectNav.js